"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeAvailableSagas = void 0;
var effects_1 = require("redux-saga/effects");
var PlaceAction_1 = require("@/pages/place/actions/PlaceAction");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var EnquireAction_1 = require("@/pages/common/actions/EnquireAction");
var SaveSearchApiSaga_1 = require("@/pages/search/sagas/api/SaveSearchApiSaga");
var UserPropertiesCrud_1 = require("@/pages/saveproperties/sagas/UserPropertiesCrud");
var UserAction_1 = require("@/pages/common/actions/UserAction");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var getSaveSearchId = function (state) { return state.place.saveSearchId; };
var setInitAvailableItemIsSaved = function () {
    var ids;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.getSavedPropertyIds)];
            case 1:
                ids = _a.sent();
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setAvailableItemsIsSaved(ids, true))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchOnPropertyLinkClicked = function () {
    var action, link;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_PROPERTY_LINK_CLICKED)];
            case 1:
                action = _a.sent();
                link = action.payload;
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.globalSetUrl(link))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnPropertyEnquireClicked = function () {
    var action, item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_PROPERTY_ENQUIRE_CLICKED)];
            case 1:
                action = _a.sent();
                item = action.payload;
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.onEnquireClick(item))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
// const watchFollowPopupSaga = function* () {
//   while (true) {
//     yield take(PlaceAction.PLACE_FOLLOW_CLICKED);
//     yield put(PlaceAction.onFollowPopupCloseClick());
//   }
// };
var watchUnfollowSaga = function () {
    var saveSearchId, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_UNFOLLOW_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getSaveSearchId)];
            case 2:
                saveSearchId = _a.sent();
                return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.removeSaveSearchApi, saveSearchId)];
            case 3:
                response = _a.sent();
                if (!(response && !response.data.hasError)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setSaveSearchId(-1))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setFollowPopupActive(false))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var watchFavClicked = function () {
    var payload, item, isSaved, isDeleted;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.take(PlaceAction_1.default.PLACE_FAV_CLICKED)];
            case 1:
                payload = (_a.sent()).payload;
                item = payload;
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setLastSavedProperty(null))];
            case 2:
                _a.sent();
                if (!!item.isSaved) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.addSavedProperties, [item])];
            case 3:
                isSaved = _a.sent();
                if (!isSaved) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setAvailableItemIsSaved(Number(item.referenceId), true))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setLastSavedProperty(item))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('save_property_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'sucessSaveProperty'))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 11];
            case 8: return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.deleteSavedProperties, [Number(item.referenceId)])];
            case 9:
                isDeleted = _a.sent();
                if (!isDeleted) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.put(PlaceAction_1.default.setAvailableItemIsSaved(Number(item.referenceId), false))];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [3 /*break*/, 0];
            case 12: return [2 /*return*/];
        }
    });
};
var watchInit = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(setInitAvailableItemIsSaved)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchLogin = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(UserAction_1.default.SET_USER_DONE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(setInitAvailableItemIsSaved)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var placeAvailableSagas = {
    watchOnPropertyLinkClicked: watchOnPropertyLinkClicked,
    watchOnPropertyEnquireClicked: watchOnPropertyEnquireClicked,
    watchUnfollowSaga: watchUnfollowSaga,
    watchFavClicked: watchFavClicked,
    watchInit: watchInit,
    watchLogin: watchLogin,
};
exports.placeAvailableSagas = placeAvailableSagas;
